export default function OfferBanner({ text, children }) {
	return (text || children) && (
		<div id="offerBanner" className="pf t0 l0 zi5 w100 bg6 df fww jcc aic py1rem">
			{text && <h4 className="c1 fw600 fs1-25rem-sm">{text}</h4>}
			{children}
		</div>
	);
}
